import Image from 'next/image'
import { FC } from 'react'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { PageType } from '@/components/entities/requests/model/types'
import { AppButton } from '@/components/shared/button'

type Props = {
  pageType: PageType
  onClose: () => void
}

const RequestCancelled: FC<Props> = ({ pageType, onClose }) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  return (
    <>
      <div className="mt-[-210px] flex flex-grow flex-col items-center justify-center sm:mt-0">
        <Image
          src="/images/shared/CheckMark.png"
          width={isMobileScreen ? 90 : 180}
          height={isMobileScreen ? 90 : 180}
          alt="request-cancelled"
          className="flex justify-center"
        />
        <p className="mt-22 text-center text-grey-70 text-20 sm:text-16">
          Детали и статус вы можете посмотреть в разделе «
          {pageType === PageType.Requests ? 'Обращения' : 'Пропуска'}»
        </p>
      </div>

      <AppButton
        fluid
        size={isMobileScreen ? 'small' : 'large'}
        onClick={onClose}
        className="mb-20 mt-auto sm:mb-10"
        variant="secondary"
        data-testid="request-cancelled-close-button-id"
      >
        Понятно
      </AppButton>
    </>
  )
}

export { RequestCancelled }
